import React from 'react'
import MaintenancePage from '../../Pages/maintainnance/MaintenancePage'

const GreatLakes = () => {
  return (
    <>
    <MaintenancePage />
    </>
  )
}

export default GreatLakes